import { call, put, takeLatest } from "redux-saga/effects";
import { studentAPI } from "../../../services/student/index"
import { submitConsent, SUBMIT_CONSENT} from "../../actions/student.action"

function* handleSubmitConsent(action) {
  try {
    const { data : resData} = yield call(studentAPI.submitConsent, action.payload);
    //extract the data here     
    yield put(submitConsent.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(submitConsent.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* submitConsentSaga() {
  yield takeLatest(SUBMIT_CONSENT.REQUEST, handleSubmitConsent);
}

export default submitConsentSaga;
